import {createApp} from 'vue'
import App from './App.vue'
import router from './router'//路由
import store from './store'//状态管理
import 'amfe-flexible';//引入 解决页面适配 rem
import '@/assets/css/common.css'//公共样式文件
import { Divider,Col, Row,Toast } from 'vant';

router.beforeEach((to, from, next) => {
    if (to.meta.title) document.title = to.meta.title;
    next()
})

createApp(App).use(store).use(router).use(Divider).use(Col).use(Row).use(Toast).mount('#app')
